var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 893,
    height: 181,
    viewBox: "0 0 893 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 446.5,
    cy: 41.5,
    rx: 446.5,
    ry: 41.5,
    transform: "matrix(-1 0 0 1 893 97.001)",
    fill: "#D9D9D9",
    fillOpacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.135 55.7068C494.078 74.7132 499.492 93.9579 490.501 101.5L487.001 97.5C493.794 91.8018 486.2 73.4052 474.155 59.0454C462.109 44.6855 446.793 37.3018 440 43L433 35C441.991 27.4579 462.192 36.7004 478.135 55.7068Z",
    fill: "#CCCFD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.71 81.7457C354.79 82.5347 355.712 82.9214 356.331 82.4251L395.089 51.3264C395.941 50.6423 395.235 49.2821 394.185 49.5859L361.962 58.908L364.279 36.5126C364.371 35.6252 363.343 35.0708 362.652 35.6351L318.732 71.4983C318.314 71.8392 318.658 72.5084 319.178 72.3684L352.847 63.3125L354.71 81.7457Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.083 117.914L367.105 119.647C365.008 119.612 353.155 119.937 320.451 119.389C288.68 121.994 280.361 102.73 278.93 77.5173C278.332 66.9761 278.938 55.3948 279.537 43.9369C279.571 43.2882 279.605 42.6399 279.638 41.9922C279.726 40.2977 279.813 38.6073 279.894 36.9248C281.505 3.39938 312.804 0.975727 331.872 1.099C348.821 1.20857 390.056 1.55081 419.406 2.04316C448.756 2.53552 456.027 27.4721 455.993 39.8789L455.325 79.7109C454.847 108.222 431.631 117.06 420.083 117.914ZM383.801 93.19L325.066 94.3017C312.523 91.994 297.508 80.7331 298.445 56.1091C299.195 36.4099 321.471 27.3119 332.516 25.2252L370.269 24.81C383.724 24.861 411.051 31.3658 412.718 56.9773C414.385 82.5889 394.135 91.7906 383.801 93.19ZM429.946 30.0052L428.962 88.705C428.962 88.705 431.998 92.3665 434.665 92.4705C437.615 92.5854 441.025 88.3831 441.025 88.3831L440.961 29.6657C440.961 29.6657 437.711 26.8262 435.24 26.9485C432.856 27.0664 429.946 30.0052 429.946 30.0052Z",
    fill: "#323232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.714 77.2597L278.93 77.5173C278.332 66.9761 278.938 55.3948 279.537 43.9369C279.571 43.2882 279.605 42.6399 279.638 41.9922C252.613 41.7705 191.113 41.5166 161.323 42.275C151.971 47.9237 148.202 53.4557 147.702 58.4424L261.764 57.452L261.76 58.6326L147.643 59.6284C147.655 67.4285 155.491 73.7578 161.791 76.8836L180.659 77.2001C193.05 63.5677 204.701 71.1376 208.978 76.6267L225.749 76.908L237.438 67.6675L246.714 77.2597Z",
    fill: "#DEDEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M455.325 79.7109C454.847 108.222 431.631 117.06 420.083 117.914L367.105 119.647C365.008 119.612 353.155 119.937 320.451 119.389C288.68 121.994 280.361 102.73 278.93 77.5173M455.325 79.7109C455.803 51.1995 455.97 41.2765 455.993 39.8789M455.325 79.7109L455.993 39.8789M455.993 39.8789C456.027 27.4721 448.756 2.53552 419.406 2.04316C390.056 1.55081 348.821 1.20857 331.872 1.099C312.804 0.975727 281.505 3.39938 279.894 36.9248C279.813 38.6073 279.726 40.2977 279.638 41.9922M278.93 77.5173L246.714 77.2597L237.438 67.6675L225.749 76.908L208.978 76.6267C204.701 71.1376 193.05 63.5677 180.659 77.2001M278.93 77.5173C278.332 66.9761 278.938 55.3948 279.537 43.9369C279.571 43.2882 279.605 42.6399 279.638 41.9922M180.659 77.2001C167.242 76.975 162.49 76.8953 161.791 76.8836M180.659 77.2001L161.791 76.8836M161.791 76.8836C155.491 73.7578 147.655 67.4285 147.643 59.6284M161.323 42.275C191.113 41.5166 252.613 41.7705 279.638 41.9922M161.323 42.275C151.223 48.3756 147.635 54.3401 147.643 59.6284M161.323 42.275C151.971 47.9237 148.202 53.4557 147.702 58.4424M147.643 59.6284L261.76 58.6326L261.764 57.452L147.702 58.4424M147.643 59.6284C147.642 59.2367 147.662 58.8413 147.702 58.4424M325.066 94.3017L383.801 93.19C394.135 91.7906 414.385 82.5889 412.718 56.9773C411.051 31.3658 383.724 24.861 370.269 24.81L332.516 25.2252C321.471 27.3119 299.195 36.4099 298.445 56.1091C297.508 80.7331 312.523 91.994 325.066 94.3017ZM361.962 58.908L394.185 49.5859C395.235 49.2821 395.941 50.6423 395.089 51.3264L356.331 82.4251C355.712 82.9214 354.79 82.5347 354.71 81.7457L352.847 63.3125L319.178 72.3684C318.658 72.5084 318.314 71.8392 318.732 71.4983L362.652 35.6351C363.343 35.0708 364.371 35.6252 364.279 36.5126L361.962 58.908ZM428.962 88.705L429.946 30.0052C429.946 30.0052 432.856 27.0664 435.24 26.9485C437.711 26.8262 440.961 29.6657 440.961 29.6657L441.025 88.3831C441.025 88.3831 437.615 92.5854 434.665 92.4705C431.998 92.3665 428.962 88.705 428.962 88.705Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M716.071 71C718.241 71 720 73.0576 720 75.5957V120.404C720 122.942 718.241 125 716.071 125H488.664C486.747 125 485.151 123.395 484.805 121.271C484.713 120.711 484.568 120.151 484.256 119.677L471.051 99.5977C470.413 98.628 470.413 97.372 471.051 96.4023L484.256 76.323C484.568 75.8486 484.713 75.2892 484.805 74.7287C485.151 72.6051 486.747 71 488.664 71H716.071ZM488.664 92.5426C491.046 92.5426 492.533 95.2146 492.593 98C492.655 100.872 491.12 103.745 488.664 103.745C486.208 103.745 484.673 100.872 484.735 98C484.795 95.2146 486.282 92.5426 488.664 92.5426Z",
    fill: "#AA2E27"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 716 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 708 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 700 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 692 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 684 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 676 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 668 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 660 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 652 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 644 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 636 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 628 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 620 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 612 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 604 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 596 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 588 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 580 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 572 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 564 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 556 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 548 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 540 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 532 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 524 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 516 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 508 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 500 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 492 75)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 716 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 708 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 700 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 692 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 684 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 676 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 668 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 660 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 652 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 644 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 636 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 628 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 620 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 612 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 604 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 596 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 588 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 580 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 572 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 564 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 556 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 548 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 540 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 532 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 524 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 516 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 508 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 500 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 492 114)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 716 84)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 716 94)",
    fill: "black",
    fillOpacity: 0.15
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 3.5,
    rx: 2,
    ry: 3.5,
    transform: "matrix(-1 0 0 1 716 104)",
    fill: "black",
    fillOpacity: 0.15
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M547.616 90.32V92.552H540.536V97.472H546.056V99.704H540.536V107H537.8V90.32H547.616ZM557.76 107.168C556.208 107.168 554.776 106.808 553.464 106.088C552.168 105.352 551.136 104.336 550.368 103.04C549.616 101.728 549.24 100.256 549.24 98.624C549.24 96.992 549.616 95.528 550.368 94.232C551.136 92.936 552.168 91.928 553.464 91.208C554.776 90.472 556.208 90.104 557.76 90.104C559.328 90.104 560.76 90.472 562.056 91.208C563.368 91.928 564.4 92.936 565.152 94.232C565.904 95.528 566.28 96.992 566.28 98.624C566.28 100.256 565.904 101.728 565.152 103.04C564.4 104.336 563.368 105.352 562.056 106.088C560.76 106.808 559.328 107.168 557.76 107.168ZM557.76 104.792C558.864 104.792 559.848 104.544 560.712 104.048C561.576 103.536 562.248 102.816 562.728 101.888C563.224 100.944 563.472 99.856 563.472 98.624C563.472 97.392 563.224 96.312 562.728 95.384C562.248 94.456 561.576 93.744 560.712 93.248C559.848 92.752 558.864 92.504 557.76 92.504C556.656 92.504 555.672 92.752 554.808 93.248C553.944 93.744 553.264 94.456 552.768 95.384C552.288 96.312 552.048 97.392 552.048 98.624C552.048 99.856 552.288 100.944 552.768 101.888C553.264 102.816 553.944 103.536 554.808 104.048C555.672 104.544 556.656 104.792 557.76 104.792ZM577.636 107L573.796 100.328H571.708V107H568.972V90.32H574.732C576.012 90.32 577.092 90.544 577.972 90.992C578.868 91.44 579.532 92.04 579.964 92.792C580.412 93.544 580.636 94.384 580.636 95.312C580.636 96.4 580.316 97.392 579.676 98.288C579.052 99.168 578.084 99.768 576.772 100.088L580.9 107H577.636ZM571.708 98.144H574.732C575.756 98.144 576.524 97.888 577.036 97.376C577.564 96.864 577.828 96.176 577.828 95.312C577.828 94.448 577.572 93.776 577.06 93.296C576.548 92.8 575.772 92.552 574.732 92.552H571.708V98.144ZM593.064 98.432C593.96 98.592 594.72 99.064 595.344 99.848C595.968 100.632 596.28 101.52 596.28 102.512C596.28 103.36 596.056 104.128 595.608 104.816C595.176 105.488 594.544 106.024 593.712 106.424C592.88 106.808 591.912 107 590.808 107H584.136V90.32H590.496C591.632 90.32 592.608 90.512 593.424 90.896C594.24 91.28 594.856 91.8 595.272 92.456C595.688 93.096 595.896 93.816 595.896 94.616C595.896 95.576 595.64 96.376 595.128 97.016C594.616 97.656 593.928 98.128 593.064 98.432ZM586.872 97.328H590.256C591.152 97.328 591.848 97.128 592.344 96.728C592.856 96.312 593.112 95.72 593.112 94.952C593.112 94.2 592.856 93.616 592.344 93.2C591.848 92.768 591.152 92.552 590.256 92.552H586.872V97.328ZM590.568 104.768C591.496 104.768 592.224 104.544 592.752 104.096C593.28 103.648 593.544 103.024 593.544 102.224C593.544 101.408 593.264 100.76 592.704 100.28C592.144 99.8 591.4 99.56 590.472 99.56H586.872V104.768H590.568ZM601.989 90.32V107H599.253V90.32H601.989ZM611.029 90.32C612.805 90.32 614.357 90.664 615.685 91.352C617.029 92.024 618.061 93 618.781 94.28C619.517 95.544 619.885 97.024 619.885 98.72C619.885 100.416 619.517 101.888 618.781 103.136C618.061 104.384 617.029 105.344 615.685 106.016C614.357 106.672 612.805 107 611.029 107H605.581V90.32H611.029ZM611.029 104.768C612.981 104.768 614.477 104.24 615.517 103.184C616.557 102.128 617.077 100.64 617.077 98.72C617.077 96.784 616.557 95.272 615.517 94.184C614.477 93.096 612.981 92.552 611.029 92.552H608.317V104.768H611.029ZM628.045 90.32C629.821 90.32 631.373 90.664 632.701 91.352C634.045 92.024 635.077 93 635.797 94.28C636.533 95.544 636.901 97.024 636.901 98.72C636.901 100.416 636.533 101.888 635.797 103.136C635.077 104.384 634.045 105.344 632.701 106.016C631.373 106.672 629.821 107 628.045 107H622.597V90.32H628.045ZM628.045 104.768C629.997 104.768 631.493 104.24 632.533 103.184C633.573 102.128 634.093 100.64 634.093 98.72C634.093 96.784 633.573 95.272 632.533 94.184C631.493 93.096 629.997 92.552 628.045 92.552H625.333V104.768H628.045ZM642.348 92.528V97.424H648.108V99.656H642.348V104.768H648.828V107H639.612V90.296H648.828V92.528H642.348ZM665.902 107H663.166L654.934 94.544V107H652.198V90.296H654.934L663.166 102.728V90.296H665.902V107Z",
    fill: "#E7E7E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M483.864 97.9094C483.79 101.725 485.805 104.859 488.365 104.909C490.924 104.959 493.06 101.906 493.135 98.0904C493.209 94.2744 491.194 91.1404 488.634 91.0904C486.075 91.0404 483.939 94.0934 483.864 97.9094ZM492.001 98.0683C491.945 100.951 490.332 103.258 488.398 103.22C486.463 103.182 484.941 100.815 484.998 97.9315C485.054 95.0484 486.667 92.7418 488.601 92.7796C490.536 92.8173 492.058 95.1852 492.001 98.0683Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M483.864 97.9094C483.79 101.725 485.805 104.859 488.365 104.909C490.924 104.959 493.06 101.906 493.135 98.0904C493.209 94.2744 491.194 91.1404 488.634 91.0904C486.075 91.0404 483.939 94.0934 483.864 97.9094ZM492.001 98.0683C491.945 100.951 490.332 103.258 488.398 103.22C486.463 103.182 484.941 100.815 484.998 97.9315C485.054 95.0484 486.667 92.7418 488.601 92.7796C490.536 92.8173 492.058 95.1852 492.001 98.0683Z",
    fill: "url(#paint0_linear_615_1141)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M446.293 82.4819C462.458 101.3 481.901 108.852 490.803 101.205L487.303 97.2048C480.578 102.982 462.447 93.3142 450.234 79.0968C438.021 64.8794 433.274 48.7776 440 43L433 34.9999C424.098 42.6471 430.128 63.664 446.293 82.4819Z",
    fill: "#CCCFD7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_615_1141",
    x1: 488.634,
    y1: 91.0904,
    x2: 488.365,
    y2: 104.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#867C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964343",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/accessDenied.1f9b0bde587816858f767a0007910250.svg";
export { ForwardRef as ReactComponent };